import React from 'react';
import { motion } from 'framer-motion';
import { DeviceMobile, Code, Database, RocketLaunch } from '@phosphor-icons/react';

const FloatingUICard = ({ children, className, ...props }) => (
  <motion.div
    {...props}
    className={`absolute bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-lg shadow-xl ${className}`}
  >
    {children}
  </motion.div>
);

const AppDevHero = ({ title, subtitle }) => {
  return (
    <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden">
      {/* Background dot pattern */}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(rgba(59,130,246,0.3)_1px,transparent_1px)] [background-size:1.5rem_1.5rem]"></div>

      <div className="container mx-auto px-4 py-24 sm:py-48 relative z-10">
        <div className="relative">
          <div className="relative z-10 flex flex-col justify-center items-center text-center">
            <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
                className="text-4xl sm:text-5xl font-bold font-heading mb-4 text-white"
            >
              {title}
            </motion.h1>
            <motion.p 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.1, ease: 'easeOut' }}
                className="text-lg text-blue-100 max-w-2xl mx-auto"
            >
              {subtitle}
            </motion.p>
          </div>

          <motion.div 
            className="absolute inset-0 hidden lg:block"
            initial="initial"
            animate="animate"
          >
            {/* Mobile Device */}
            <FloatingUICard
              variants={{ initial: { opacity: 0, y: -40, rotate: 15 }, animate: { opacity: 1, y: 0, rotate: 5 } }}
              transition={{ duration: 0.7, delay: 0.5, ease: 'circOut' }}
              className="p-4 top-[-4rem] left-[15%] xl:left-[20%]"
            >
              <DeviceMobile size={40} className="text-gray-600" weight="light" />
            </FloatingUICard>
            
            {/* Code Snippet */}
            <FloatingUICard
                variants={{ initial: { opacity: 0, y: 40, scale: 0.8 }, animate: { opacity: 1, y: 0, scale: 1 } }}
                transition={{ duration: 0.7, delay: 0.7, ease: 'circOut' }}
                className="p-4 bottom-[-4rem] left-[12%] xl:left-[18%]"
            >
                <Code size={32} className="text-gray-600" weight="light" />
            </FloatingUICard>

            {/* Database */}
            <FloatingUICard
                variants={{ initial: { opacity: 0, y: -20, rotate: -15 }, animate: { opacity: 1, y: 0, rotate: -8 } }}
                transition={{ duration: 0.7, delay: 0.6, ease: 'circOut' }}
                className="p-4 top-[-3rem] right-[10%] xl:right-[15%]"
            >
                <Database size={36} className="text-gray-600" weight="light" />
            </FloatingUICard>
            
            {/* Rocket for Deployment */}
            <FloatingUICard
                variants={{ initial: { opacity: 0, y: 50, rotate: 20 }, animate: { opacity: 1, y: 0, rotate: 15 } }}
                transition={{ duration: 0.7, delay: 0.8, ease: 'circOut' }}
                className="p-4 bottom-[-4rem] right-[12%] xl:right-[18%]"
            >
              <RocketLaunch size={32} className="text-gray-600" weight="light" />
            </FloatingUICard>

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AppDevHero; 